
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signup/user",
      function () {
        return require("private-next-pages/signup/user.tsx");
      }
    ]);
  